<div class="account-wrapper">
    <div class="row">
        <gol-account-navigation-dashboard class="col-md-3 account-navigation" [account]="account"
            [loan_number]="account?.LoanNumber"></gol-account-navigation-dashboard>
        <div class="account-stage col-md-9">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>